/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingInfo
 */
export interface BillingInfo {
    /**
     * 企業ID
     * @type {number}
     * @memberof BillingInfo
     */
    companyId: number;
    /**
     * 請求先企業名
     * @type {string}
     * @memberof BillingInfo
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof BillingInfo
     */
    zipCode: string;
    /**
     * 住所（都道府県/市町村/番地）
     * @type {string}
     * @memberof BillingInfo
     */
    address: string;
    /**
     * 住所（建物名/階数）
     * @type {string}
     * @memberof BillingInfo
     */
    buildingName: string | null;
    /**
     * 部門
     * @type {string}
     * @memberof BillingInfo
     */
    dept: string | null;
    /**
     * 請求書送付先のメールアドレス
     * @type {string}
     * @memberof BillingInfo
     */
    email: string;
    /**
     * 請求書送付先のメールアドレス（cc）
     * @type {string}
     * @memberof BillingInfo
     */
    emailCc: string | null;
    /**
     * 請求担当者の苗字（本当はlast_name）
     * @type {string}
     * @memberof BillingInfo
     */
    firstName: string;
    /**
     * 請求担当者の名前（本来はfirst_name）
     * @type {string}
     * @memberof BillingInfo
     */
    lastName: string;
    /**
     * 請求担当者の苗字のカナ（本当はlast_name）
     * @type {string}
     * @memberof BillingInfo
     */
    firstKanaName: string;
    /**
     * 請求担当者の名前のカナ（本当はfirst_name）
     * @type {string}
     * @memberof BillingInfo
     */
    lastKanaName: string;
}

export function BillingInfoFromJSON(json: any): BillingInfo {
    return BillingInfoFromJSONTyped(json, false);
}

export function BillingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'zipCode': json['zip_code'],
        'address': json['address'],
        'buildingName': json['building_name'],
        'dept': json['dept'],
        'email': json['email'],
        'emailCc': json['email_cc'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'firstKanaName': json['first_kana_name'],
        'lastKanaName': json['last_kana_name'],
    };
}

export function BillingInfoToJSON(value?: BillingInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'zip_code': value.zipCode,
        'address': value.address,
        'building_name': value.buildingName,
        'dept': value.dept,
        'email': value.email,
        'email_cc': value.emailCc,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'first_kana_name': value.firstKanaName,
        'last_kana_name': value.lastKanaName,
    };
}

